enum PushNotificationEvents {
  WEB_LINK = "WEB_LINK",
  CUSTOM = "CUSTOM",
}

export default PushNotificationEvents;
